import NewRoleDialog from './roleDialog.container'

export default NewRoleDialog